import { Component } from '@angular/core';
import { PopoverController } from 'ionic-angular';

import { PopoverPage } from '../about-popover/about-popover';

declare var dataLayer: Array<any>;

@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
})
export class AboutPage {
  todaysDate = '2017-07-01';

  constructor(public popoverCtrl: PopoverController) { }

  presentPopover(event: Event) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({ ev: event });
  }

  ionViewDidLoad() {
    dataLayer.push({
      'screenPath': 'about.html',
      'screenName': 'AboutPage'
    });
    dataLayer.push({'event': 'appScreenView'});
  }
}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts